module.exports = __webpack_public_path__ + "static/media/gifts@2x.84be2fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/gifts@2x.png
// module id = 1054
// module chunks = 49